<template>
  <transition name="fade">
    <div v-if="dynamicFilters.length" class="main-filter__group">
      <FilterGroup v-for="filter in dynamicFilters"
                   :key="filter.slug"
                   :title="filter.title"
                   :open-default="true"
                   class="main-filter__group"
      >
        <!--  checkbox  -->
        <div v-if="filter.type === 'checkboxes'"
             class="main-filter__check-list">
          <BaseCheckbox v-for="item in filter.data"
                        :key="item.id"
                        :label="item.title"
                        :checked="isChecked(item.slug)"
                        @input="onCheckboxInput($event, item.slug)"
                        :route="generateCheckboxRoute(item)"
                        class="main-filter__checkbox"/>
        </div>

        <div v-else-if="filter.type === 'style-checkboxes'"
             class="main-filter__check-list">
          <BaseCheckbox v-for="item in filter.data"
                        :key="item.id"
                        :label="item.title"
                        :checked="isChecked(item.slug)"
                        @input="onCheckboxInput($event, item.slug)"
                        :route="generateCheckboxRoute(item)"
                        class="main-filter__checkbox _benefits"
          >
            <BaseSvg v-if="item.id === 'observation_housing'"
                     name="ico-thermometer"
                     slot="ico"/>
            <BaseSvg v-if="item.id === 'housing'"
                     name="ico-house"
                     slot="ico"/>
            <BaseSvg v-if="item.id === 'meals'"
                     name="ico-cutlery"
                     slot="ico"/>
            <BaseSvg v-if="item.id === 'transport'"
                     name="ico-transport"
                     slot="ico"/>
            <BaseSvg v-if="item.id === 'clothes'"
                     name="ico-t-shirt"
                     slot="ico"/>
          </BaseCheckbox>
        </div>
        <div v-else>Else</div>
      </FilterGroup>
    </div>
  </transition>
</template>

<script>
  import {mapState} from 'vuex'
  import FilterGroup from './FilterGroup'
  import filterMixin from '@/mixins/filterMixin'
  import toggleDynamicFilterKeyInRoute from '@/store/vacancies/common/toggleDynamicFilterKeyInRoute'
  import createNewDynamicFiltersList from '@/store/vacancies/common/createNewDynamicFiltersList'
  import createRoute from '@/store/vacancies/common/createRoute'

  export default {
    mixins: [filterMixin],
    components: {
      FilterGroup,
    },
    computed: {
      ...mapState('vacancies', [
        'dynamicFilters',
        'dynamicRouteFilters',
      ])
    },
    methods: {
      //checkbox
      onCheckboxInput($value, slug) {
        toggleDynamicFilterKeyInRoute([$value, slug])
      },
      isChecked(slug) {
        return (this.dynamicRouteFilters || []).includes(slug)
      },

      generateCheckboxRoute(filterItem) {
        if (!filterItem.index) return null;

        const { href } = this.createCheckboxRoute(filterItem.slug);
        let newPath = href;

        if (href.startsWith(`/${this.$store.state.defaultLocale}/`)) {
          newPath = href.slice(this.$store.state.defaultLocale.length + 1);
        }

        const currentFullPath = location.href.slice(location.origin.length);

        return newPath === currentFullPath ? null : newPath;
      },
      createCheckboxRoute(slug) {
        const route = createRoute({
          params: {
            dynamicFilters: createNewDynamicFiltersList([true, slug])
          }
        });

        return this.$router.resolve({ ...this.$route, ...this.$router.match(route) });
      },
    },
  }
</script>

<style>

</style>
